import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import GppGoodIcon from "@mui/icons-material/GppGood";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PsychologyIcon from "@mui/icons-material/Psychology";
import RouteIcon from "@mui/icons-material/Route";
import VerifiedIcon from "@mui/icons-material/Verified";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Typography,
  Stack,
} from "@mui/material";
import React from "react";
import { isMobile, isDesktop } from "react-device-detect";
import TaskIcon from "@mui/icons-material/Task";
import BoltIcon from "@mui/icons-material/Bolt";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ContactForm from "../components/ContactForm";
import FormularioBomberos from "../components/FormularioBomberos";
import BatteryChargingFullIcon from "@mui/icons-material/BatteryChargingFull";
import { info } from "../helpers/Info";
import "../styles/Habilitaciones.css";
import WhatsAppButton from "../components/WhatsAppButton";
import fondo from "../assets/automotora.jpg";
import fondo2 from "../assets/automotora.jpg";
import Reviews from "../components/Reviews";
import FormularioCarteleria from "../components/FormularioCarteleria";
import SliderCarteleria from "../components/SliderCarteleria";
import TextosCarteleria from "../components/TextosCarteleria";

const carteleria = [
  {
    imagen: "../assets/automotora.jpg",
    titulo: "",
  },
  {
    imagen: "../assets/perto.jpg",
    titulo: "",
  },
  {
    imagen: "../assets/pizzativa.jpg",
    titulo: "",
  },
  {
    imagen: "../assets/pointer.jpg",
    titulo: "",
  },
  {
    imagen: "../assets/barberia.jpg",
    titulo: "",
  },
  {
    imagen: "../assets/totem1.jpg",
    titulo: "",
  },
  {
    imagen: "../assets/totem2.jpg",
    titulo: "",
  },
  {
    imagen: "../assets/totem3.jpg",
    titulo: "",
  },
];

const insumos = [
  {
    titulo: "Bastidor en Aluminio Compuesto (Alucobond)",
    texto:
      "Fachadas modernas, elegantes y resistentes. Paneles de aluminio compuesto ideales para locales, edificios corporativos y señalética exterior.",
  },
  {
    titulo: "Letras Corpóreas en Acrílico",
    texto:
      "Terminaciones limpias, modernas y de alto impacto visual. Disponibles con iluminación LED frontal o backlight.",
  },
  {
    titulo: "Letras Corpóreas en Chapa y Acero Inoxidable",
    texto:
      "Perfectas para marcas que buscan presencia sólida y premium. Fabricación robusta, precisión láser y opciones iluminadas.",
  },
  {
    titulo: "Vinilos de Corte",
    texto:
      "Aplicaciones limpias y precisas para vidrieras, vehículos, señalética interna y branding.",
  },
  {
    titulo: "Microperforado para Vidrieras",
    texto:
      "Impresión de alta calidad que permite ver desde adentro sin perder impacto visual hacia afuera.",
  },
  {
    titulo: "Impresión en Lonas",
    texto:
      "Lonas frontlight y backlight para exhibiciones, carteles promocionales, banners y eventos.",
  },
];

const Carteleria = () => {
  /*   const ENDPOINT ="https://maps.googleapis.com/maps/api/place/details/json?place_id=ChIJHezobOCBn5URqKiywMM8Ht4&fields=reviews,rating&key=AIzaSyCM_BpfwovYkq2p3eWPB2mFlaZE-RpwEuM";*/

  //--------DIRECTO A API
  //  const ENDPOINT = "https://maps.googleapis.com/maps/api/place/details/json?place_id=ChIJHezobOCBn5URqKiywMM8Ht4&fields=rating,user_ratings_total,reviews&language=es&reviews_sort=newest&key=AIzaSyCM_BpfwovYkq2p3eWPB2mFlaZE-RpwEuM"

  //---------LAMBDA
  const ENDPOINT = process.env.REACT_APP_REVIEWS_ENDPOINT;

  const PLACE_ID = process.env.REACT_APP_PLACE_ID || "";
  return (
    <Box
      className="habilitaciones"
      sx={{ paddingTop: isMobile ? "70.4px" : "86px", bgcolor: "#fff" }}
    >
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          backgroundImage: !isMobile ? `url(${fondo})` : `url(${fondo2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: !isDesktop ? "column" : "row",
          alignItems: "center",
          color: "white",
          justifyContent: "center",
          textAlign: "center",
          maxWidth: "100%",
          height: !isDesktop ? "50vh" : "calc(100vh - 86px) ",
          /* maxHeight: "100vh", */
          zIndex: 10,
        }}
      >
        <Stack
          direction="row"
          justifyContent="center"
          sx={{ height: isMobile ? "90%" : " 70%" }}
        >
          <Box
            sx={{
              zIndex: 10,
              textAlign: "center",
              width: !isDesktop ? "100%" : "40%",
              display: "flex",
              flexDirection: "column",
              /*  justifyContent: isDesktop ? "space-between" : "center", */
              justifyContent: "space-between",
              height: isDesktop ? "70%" : "100%",
              maxWidth: "700px",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                maxWidth: isDesktop ? "94%" : isMobile ? "96%" : "90%",
                fontWeight: isMobile ? 400 : 700,
                textAlign: isDesktop ? "start" : "center",
                lineHeight: isDesktop ? "3.3rem" : "",
                fontSize: isDesktop ? "3rem" : "1.5rem !important",
              }}
            >
              ¿Buscas destacar tu marca sobre el resto? Diseñamos la cartelería
              para tu negocio.
            </Typography>

            {!isDesktop && (
              <Stack
                sx={{ width: "96%", margin: "0 auto" }}
                direction="row"
                justifyContent="center"
              >
                <Button
                  variant="contained"
                  color="success"
                  sx={{
                    mt: 1,
                    fontWeight: "bold",
                    zIndex: 10,
                    width: "20rem",
                  }}
                  href={"/carteleria#contacto"}
                >
                  quiero asesoramiento
                </Button>
              </Stack>
            )}
          </Box>
          {isDesktop && (
            <Box sx={{ width: "30%" }}>
              {" "}
              <FormularioCarteleria id="carteleria" />{" "}
            </Box>
          )}
        </Stack>
        {/* Overlay negro */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1,
          }}
        />
      </Box>
      {!isDesktop && (
        <Box sx={{ maxWidth: "96% !improtant" }}>
          <ContactForm
            placeholder="Información de utilidad: localidad, dirección,  y perimetro a cercar"
            id="carteleria"
          />
        </Box>
      )}

      <Box py="2rem" sx={{ bgcolor: "#fafafa" }}>
        <Container>
          <Box my="2rem">
            <Typography variant="h5" textTransform="uppercase" gutterBottom>
              Cartelería y totems
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
            >
              Trabajos de altísima calidad para darle un salto de calidad a tu
              negocio
            </Typography>
            <SliderCarteleria slides={carteleria} />
          </Box>
        </Container>
      </Box>

      {/* Beneficios */}
      <Box sx={{ bgcolor: "#f9f9f9" }}>
        <Container >
          <Typography
            variant="h5"
            mb={isMobile ? "1rem" : "2rem"}
            textTransform="uppercase"
            gutterBottom
          >
            Cartelería Empresarial Profesional
          </Typography>
          <Typography
            variant="h6"
            mb={isMobile ? "1rem" : "2rem"}
            textTransform="uppercase"
            gutterBottom
            sx={{fontSize: !isDesktop ? "1rem":""}}
          >
            Diseño, fabricación e instalación para potenciar la imagen de tu
            marca
          </Typography>
          <Typography
            variant="h6"
            sx={{ marginBottom: isMobile ? "1rem" : "2rem" }}
            gutterBottom
            textAlign='start'
          >
            Tu empresa necesita destacarse. Nosotros lo hacemos posible con
            cartelería corporativa de alta calidad, materiales premium y
            terminaciones profesionales pensadas para resistir el clima, el paso
            del tiempo y mantener una estética impecable.
          </Typography>
          <Typography variant="h6" textAlign='start' mb={isMobile ? "1rem" : "2rem"} gutterBottom>
            Creamos soluciones visuales a medida para fachadas, locales
            comerciales, oficinas, industrias y proyectos arquitectónicos,
            integrando diseño moderno, iluminación eficiente y materiales
            durables.
          </Typography>
          <Box >
            <TextosCarteleria insumos={insumos}/>
            
          </Box>
        </Container>
      </Box>

      {/*  <Box>
        <Reviews endpoint={ENDPOINT} limit={6} placeIdForWriteLink={PLACE_ID} />
      </Box> */}
      {/* Formulario de Contacto */}
      <Divider />
      <WhatsAppButton
        id="btn-whatsapp-carteleria"
        srOnly="Whatsapp carteleria"
        message="Hola! quiero información sobre cartelería empresarial"
      />
      {/* <ContactForm id="bomberos" /> */}
    </Box>
  );
};

export default Carteleria;
